import PropTypes from 'prop-types';
import Cross from '../../../../../../assets/icons/close.svg?react';
import CheckMark from '../../../../../../assets/icons/checkmark.svg?react';
import { IconContainer } from '../styles';

const ResultIcon = ({ failure }) => {
    const Icon = failure ? <Cross /> : <CheckMark />;

    return <IconContainer failure={failure}>{Icon}</IconContainer>;
};

ResultIcon.defaultProps = {
    failure: false,
};

ResultIcon.propTypes = {
    failure: PropTypes.bool,
};

export default ResultIcon;
